import { render, staticRenderFns } from "./ProfileLayout.vue?vue&type=template&id=2450c444&scoped=true&"
import script from "./ProfileLayout.vue?vue&type=script&lang=ts&"
export * from "./ProfileLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450c444",
  null
  
)

export default component.exports